import {
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileNotNoneContext } from "../../../../selectors/selectorIsSharedFileNotNoneContext";

export const getSharedFileIsValidatingActive = (
  sharedFileRequest: SharedFileRequest | undefined
): boolean => {
  return (
    selectorIsSharedFileNotNoneContext(sharedFileRequest?.contextType) &&
    sharedFileRequest?.status === SharedFileRequestStatus.PROCESSING
  );
};
